import { CommonModule } from '@angular/common';
import { Component, effect, inject, signal, untracked } from '@angular/core';
import { FormsModule } from '@angular/forms';
import { PilotArea, SbcApiService } from '../services/sbc-api.service';
import { SessionService } from '../../../core/services/session.service';

import { StatusBadgeComponent } from '../components/status-badge.component';

import { PageBackButtonComponent } from '../../../shared/components/page-back-button/page-back-button.component';
import { PageRefreshButtonComponent } from '../../../shared/components/page-refresh-button/page-refresh-button.component';

@Component({
  selector: 'app-pilots',
  standalone: true,
  imports: [CommonModule, FormsModule, StatusBadgeComponent, PageRefreshButtonComponent, PageBackButtonComponent],
  templateUrl: './pilots.component.html',
})
export class PilotsComponent {
  private readonly api = inject(SbcApiService);
  readonly session = inject(SessionService);

  rows = signal<PilotArea[]>([]);
  error = signal('');
  toast = signal('');
  addFormOpen = signal(false);
  expandedPilotId = signal<number | null>(null);

  form = { name: '', boundaryRef: '', notes: '', statusCd: 'active' };

  constructor() {
    effect(() => {
      this.session.authorityId();
      untracked(() => this.reload());
    });
  }

  reload(): void {
    this.api.listPilotAreas().subscribe({
      next: (res) => this.rows.set(res.data || []),
      error: (err) => this.error.set(err?.error?.message || 'Failed to load pilots'),
    });
  }

  toggleAddForm(): void {
    this.addFormOpen.update((v) => !v);
  }

  isPilotExpanded(r: PilotArea): boolean {
    return this.expandedPilotId() === r.id;
  }

  togglePilotDetail(r: PilotArea): void {
    this.expandedPilotId.set(this.expandedPilotId() === r.id ? null : r.id);
  }

  create(): void {
    this.api.createPilotArea({ ...this.form }).subscribe({
      next: () => {
        this.showToast('Pilot area created');
        this.form = { name: '', boundaryRef: '', notes: '', statusCd: 'active' };
        this.reload();
      },
      error: (err) => this.showToast(err?.error?.message || 'Create failed (switch to Config Admin)'),
    });
  }

  private showToast(msg: string): void {
    this.toast.set(msg);
    setTimeout(() => this.toast.set(''), 3200);
  }
}
